import React from 'react';

const NotFound = () => {
  return (
    <main>
      <h2>Not Found</h2>
      <p>Here a few things to do while we look for this page</p>
      <ul>
        <li> Volunteer - Another way that you can help is to donate your time by volunteering. Contact agenciess that you see listed and see how you can volunteer.</li>
        <li>Donate - Most of the agencies listed accept donations. Feel free to go to their websites or give them a call to find out how you can donate.</li>
        <li>Political Activism - Support affordable housing initiatives, many cities lack of affordable housing.</li>
        <li>Support libraries. Local libraries are a huge resource for homeless people.</li>
        <li>Respect - One of the best ways to help a homeless person is to show them respect. Don't make assumptions or judge.</li>
      </ul>        
    </main>
  );
}

export default NotFound;